import { QueryResult } from "@apollo/client/react/types/types";
import { CriticalIllnessPolicyCoverage } from "../generated/graphql";
import { AuthContextProps } from "oidc-react";
import { usePolicy } from "./usePolicy";
import _ from "lodash";
import { Relationship } from "../component/enums/Relationship";
import { getDefaultBenefitSchedules } from "../component/enums/Illness";
import { BenefitSchedule } from "../component/domain/BenefitSchedule";

export function useBenefitSchedules(policyId?: string, memberId?: string, effectiveDate?: string, relationship?: Relationship, auth?: AuthContextProps): QueryResult<{ findBenefitSchedules:  BenefitSchedule[] }> {
    const user = auth?.userData;
    const signedIn = !!user;

    const { data: policyData, loading: policyLoading, error: policyError } = usePolicy(policyId, memberId, effectiveDate, auth)
    const defaultBenefitSchedules = getDefaultBenefitSchedules()
        .filter(benefitSchedule => Relationship.EMPLOYEE === relationship ? benefitSchedule?.isChildhoodOnlyCondition !== true : true)
    if(!signedIn || policyId?.length !== 7 || memberId?.length !== 9 || !effectiveDate || !policyData || policyError) {
        return { data: { findBenefitSchedules: defaultBenefitSchedules }, loading: policyLoading, error: policyError } as QueryResult;
    }
    const coverage = (policyData?.findPolicy?.memberGroups?.[0]?.coverages as any)?.criticalIllness as CriticalIllnessPolicyCoverage;
    const benefitSchedules = coverage?.configuration?.benefitSchedule?.benefitsPayable
        ?.filter(benefitPayable => Relationship.EMPLOYEE === relationship ? benefitPayable?.isChildhoodOnlyCondition !== true : true)
        .map(benefitPayable => {
            return { type: convertToTitleCaseWithSpace(benefitPayable?.type), isChildhoodOnlyCondition: benefitPayable?.isChildhoodOnlyCondition}
      })
    return { data: { findBenefitSchedules: benefitSchedules }, loading: policyLoading, error: policyError } as QueryResult
}

function convertToTitleCaseWithSpace(provisionType: string | undefined) {
    if (!provisionType) {
        return ''
    }
    return _.startCase(_.toLower(provisionType?.replace(/_/g, ' ')))
}

